import { GetVariantTranslations_variantTranslations_variants } from '@src/app/generated/GetVariantTranslations';

export class VariantTranslationItem {
  varGroupId: string;
  varName: string;
  translations: { key: string, value: string }[];

  constructor(varGroupId: string, varName: string, translations: { key: string, value: string }[]) {
    this.varGroupId = varGroupId;
    this.varName = varName;
    this.translations = translations;
  }

  public static fromGql(data: GetVariantTranslations_variantTranslations_variants): VariantTranslationItem {
    return new VariantTranslationItem(
      data.varGroupId,
      data.varName,
      data.translations.map((t) => {
        return {
          key: t.key,
          value: t.value,
        };
      }
      )
    );
  }
}
